<template>
    <div >
        <v-row>
            <v-col cols="5" class="removerightpad d-flex">
              <input type="radio" name="choice" id="mobile" value="mobile" class="mr-2"  v-model="selectedOption">
              <v-select v-model="selectedCountry" :items="countries" label="Country" :disabled="selectedOption !== 'mobile'" outlined hide-details /> 
              <!--<v-text-field v-model="dialingCode" label="Code" outlined disabled hide-details/>-->
            </v-col>
            <v-col cols="7">
              <v-text-field v-model="mobile" label="Mobile" :disabled="selectedOption !== 'mobile'" outlined hide-details />
            </v-col>
        </v-row>
        <div class="text-center mt-3 mb-2">Or</div>
        <div>
            <div class="d-flex align-center">
              <input type="radio" name="choice" id="email" value="email" class="mr-2" v-model="selectedOption">
            <v-text-field :disabled="selectedOption !== 'email'" v-model="email" label="Email" outlined hide-details /> 
            </div>
        </div>
        <div class="mt-5">
            <v-text-field v-model="otp" label="OTP" outlined  hide-details/> 
        </div>
        <div class="red--text text-center" v-if="error">{{ error }}</div>
        <div class="btn-actions mt-5">
            <div class="first">
                <v-btn type="submit" @click="getotp()" class="small " color="secondary">Get OTP</v-btn>
            </div>
            <div class="second">
                <v-btn type="submit" @click="submitOtp()" :disabled="disablebtn" class="small" color="primary"> Submit </v-btn>
            </div>
        </div>
    </div>
</template>    
<script>
export default {
    data(){
      return {
        selectedCountry: 'AUS',
        dialingCode: '+61',
        mobile: '',
        countries: ['AUS', 'USA', 'UK', 'NZ'],
        countryCodes: { AUS: '+61', USA: '+1', UK: '+44', NZ: '+64' },    
        email:"", 
        otp:"",
        error:"",
        disablebtn:true,
        selectedOption: 'mobile',
       }
    },
    watch: {
    // Watch for country change and update dialing code accordingly
    selectedCountry(newCountry) {
      this.dialingCode = this.countryCodes[newCountry] || '';
    },
  },
  created() {
    // Add event listener when component is created
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    if(this.$store.getters.loggedIn)
    {
       if(typeof this.$store.getters.getRegion !== 'undefined' && this.$store.getters.getRegion != null)
       {
          if(this.$store.getters.getRegion == "Australia")
             this.selectedCountry = 'AUS';
          else if(this.$store.getters.getRegion == "United States")
             this.selectedCountry = 'USA';
          else if(this.$store.getters.getRegion == "United Kingdom")
             this.selectedCountry = 'UK';
          else if(this.$store.getters.getRegion == "New Zealand")
             this.selectedCountry = 'NZ';
          else
          this.selectedCountry = "AUS";

          this.dialingCode = this.countryCodes[this.selectedCountry] || '';
          this.mobile = this.$store.getters.getMobile;
       }
       if(typeof this.$store.getters.email !== 'undefined' && this.$store.getters.email != null)
       {
          this.email = this.$store.getters.email;
       }
    } 
  },
  destroyed() {
    // Remove event listener when component is destroyed
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
   methods:
   {
    handleBeforeUnload(event) {
      const message = "Are you sure you want to leave this page?";
      event.preventDefault();
      event.returnValue = message; // This triggers the default confirmation dialog in most browsers
      localStorage.setItem('from','Auth');
      localStorage.setItem('is_reloaded', true);
      return message; // Some browsers may use this to display the alert message
    },
     getotp()
     {
        this.error = "";
        if(this.selectedOption == 'email')
        {
            if(this.email == "")
            {
                this.error = "Please enter email";
                return false;
            }
            // Simple email format validation
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if(!emailPattern.test(this.email))
            {
                this.error = "Please enter a valid email address";
                return false;
            }
        } 
        else if(this.selectedOption == 'mobile')
        {
            if(this.mobile == "")
            {
                this.error = "Please enter mobile number";
                return false;
            }
            if(this.dialingCode == "")
            {
                this.error = "Please choose country code";
                return false;
            }
        }
        else
        {
            this.error = "Please choose email or mobile";
            return false;
        }

        

        if(this.error == "")
        {   
           this.$store.dispatch("getOtp",{email:this.email,mobile:this.mobile,code:this.dialingCode,from:this.$route.name,selectedOption:this.selectedOption}).then((response) =>{
             this.disablebtn = false;
            if(response.status)
             {
                this.error = "OTP sent successfully";
             } 
             else
             {
                this.error = response.msg;
             }
           })
        }
     },
     submitOtp(){
      this.disablebtn = true;
      this.$store.dispatch("submitOtp",
         {email:this.email,mobile:this.mobile,code:this.dialingCode,from:this.$route.name,otp:this.otp,selectedOption:this.selectedOption}).then((response) =>{
             if(response.status)
             {
              console.log(this.$route.name);
                if(this.$route.name == "Auth")
                {
                  //this.$router.push({ name: "home" });
                  const data = "success";
                     this.$emit('update-message', data);
                 
                }  
                else
                {
                   this.$emit("value-sent", "correct");
                }
             } 
             else
             {
              this.error = response.msg;
             
             }
             this.disablebtn = false;
       });
     }
   }
}    
</script>
<style scoped>
.btn-actions{display: flex;}
.btn-actions div.first,.btn-actions div.second{width: 50%;}
.btn-actions div.first{text-align: left;}
.btn-actions div.second{text-align: right;}
.removerightpad{padding-right: 2px !important;}
.removerightpad .d-flex{justify-content: center; align-items: center;}
</style>